module.exports = __webpack_public_path__ + "img/come-fix-you-a-plate_mobile.9505256.jpg";